import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "horizontal-progress" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CHorizontalProgress',
  props: {
    color: {},
    size: { default: 'S' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["pla-spin", [_ctx.color, _ctx.size]])
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "pla-spin--bounce1" }, null, -1),
      _createElementVNode("div", { class: "pla-spin--bounce2" }, null, -1),
      _createElementVNode("div", { class: "pla-spin--bounce3" }, null, -1)
    ]), 2)
  ]))
}
}

})